const appConfig = window.appConfig || {};
export default {
  debug: true,
  tokenStorageName: "ocppAccesToken",
  credentialsTokenStorage: "ocppCredentialToken",
  credentialsRefreshTokenStorage: "ocppCredentialsRefreshtoken",
  tokenExpireGapMin: 20,
  tokenCheckInterval: 1000 * 60 * 5,
  apiCheckInterval: 5000,
  clientSecret: "v5veuDPycyQS6vpUbi2abk5o",
  ...appConfig,
};
